import { Link } from 'react-router-dom'
import { Send } from 'lucide-react'
import RecomendacaoProfessor from '../components/RecomendacaoProfessor'
import { useAuthStore } from '../stores/authStore'

function RecomendarPage() {
  const usuario = useAuthStore(state => state.usuario)

  if (!usuario) {
    return (
      <div className="card max-w-lg text-center">
        <p className="text-sm text-gray-600 dark:text-zinc-300">Entre como professor para recomendar aulas aos alunos.</p>
        <Link to="/login?next=/recomendar" className="btn-primary mt-4 inline-flex">Entrar</Link>
      </div>
    )
  }

  return (
    <div className="space-y-6 lg:space-y-8">
      <header>
        <div className="mb-2 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-violet-50 text-violet-700 dark:bg-violet-950 dark:text-violet-300">
          <Send size={19} />
        </div>
        <h1 className="text-xl font-medium lg:text-2xl">Recomendar aula</h1>
        <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">Compartilhe conteúdos que você considera importantes para o aprendizado. A recomendação aparecerá para os alunos da turma escolhida.</p>
      </header>

      <RecomendacaoProfessor />
    </div>
  )
}

export default RecomendarPage
